import { template as template_a6964ed3e9e948e0aa014f74cfdd6cfe } from "@ember/template-compiler";
import PracticeWebsiteNav from 'client-portal/components/practice-website/nav';
import styles from './desktop-menu.module.scss';
export default template_a6964ed3e9e948e0aa014f74cfdd6cfe(`
  <div class={{styles.component}} ...attributes inert={{if @inertMenu "true"}}>
    <PracticeWebsiteNav
      class="nav"
      @model={{@model}}
      @showSectionSpecialties={{@showSectionSpecialties}}
      @showSectionTestimonials={{@showSectionTestimonials}}
      @showSectionLocations={{@showSectionLocations}}
      @locationsSectionTitle={{@locationsSectionTitle}}
    />
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
